export default __webpack_public_path__ + "static/media/flag-sierra-leone.ce3e556c.svg";